import { EnumBase } from 'hay-core-react';
import CATALOGO_TEMAS_CAPTIVE, { chaveDoTema } from './catalogoTemasCaptive';

class ConfiguracaoTemaCaptiveEnum extends EnumBase {
    constructor() {
        super(
            CATALOGO_TEMAS_CAPTIVE.map((tema) => chaveDoTema(tema.id)),
            'main.configuracao.temacaptive.lara-light.indigo',
        );
        this.groupedKeys = [
            'main.configuracao.temacaptive.lara-light',
            'main.configuracao.temacaptive.lara-dark',
            'main.configuracao.temacaptive.vela',
            'main.configuracao.temacaptive.arya',
            'main.configuracao.temacaptive.saga',
            'main.configuracao.temacaptive.viva',
        ];
    }
}

const instance = new ConfiguracaoTemaCaptiveEnum();
export default instance;
